import { render } from "./TrioPanel.vue?vue&type=template&id=170cf8c4&ts=true"
import script from "./TrioPanel.vue?vue&type=script&lang=ts"
export * from "./TrioPanel.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\adel\\Documents\\photovoltaics-presentation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__